import React, { FC } from 'react';
import { ErrorModal as ErrorModalCore, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getOnpremHostname } from 'omni-package-react-core';
import { ChangePasswordPageState } from '../../interfaces/ChangePasswordPageState';
import { setIsModalOpened } from '../../ChangePasswordPage.actions';

export interface ErrorModalProps { }

const ErrorModal: FC<ErrorModalProps> = () => {
  const { t } = useTranslation('ChangePasswordPage');
  const { isModalOpened } = useScopedSelector((state: ChangePasswordPageState) => state);
  const dispatch = useDispatch();
  const dispatchSetIsModalOpened = (isOpened: boolean) => dispatch(setIsModalOpened(isOpened));
  const onPremHostName = getOnpremHostname();

  return (
    <ErrorModalCore
      name="OktaTokenExpired"
      isOpened={isModalOpened}
      onClose={() => {
        // window.history.replaceState(this.state, '', '/');
        dispatchSetIsModalOpened(false);
        window.location.href = `${onPremHostName}/eemwpnp1/public/gologin`;
      }}
      error={t('expired')}
    />
  );
};

export default ErrorModal;
